RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.MultiSelectDropdown = RivalIQ.views.ItemView.extend({

        className: 'multi-select-dropdown',

        attributes: {
            style: 'width: 100%'
        },

        template: '#multiSelectDropdownTemplate',

        ui: {
            labelCheckboxes: 'input[type="checkbox"], label',
            dropdownMenu: '.dropdown-menu',
            dropdown: '.dropdown.dropdown-selector',
            dropdownToggle: '.dropdown-toggle',
            filterInput: '.x-item-filter',
            controlButtons: '.controls',
            applyBtn: '.x-apply',
            cancelBtn: '.x-cancel',
            searchClear: '.search-clear-icon',
            selectionSummary: '.x-selection-summary'
        },

        events: {
            'click @ui.dropdownToggle': 'onDropdownToggleClicked',
            'click @ui.dropdownMenu': 'ignoreClick',
            'show.bs.dropdown @ui.dropdown': 'onDropdownShown',
            'click @ui.cancelBtn': 'onCancelClicked',
            'click @ui.applyBtn': 'onApplyClicked',
            'click @ui.searchClear': 'onClearSearch'
        },

        eventsNotToDebounce: {
            'keyup @ui.filterInput': 'onFilterKeyup',
            'change @ui.labelCheckboxes': 'onCheckboxChange'
        },

        ignoreClick: function (e) {
            e.stopPropagation();
        },

        initialize: function () {
            const me = this;

            me._hideHandler = function (e) {
                return me.shouldCloseDropdown(e);
            };

            me._anyDropdownShown = function () {
                if (me.ui.dropdown.hasClass('open')) {
                    me.closeDropdown(true);
                }
            };

            $(document).on('hide.bs.dropdown', me._hideHandler);
            $(document).on('show.bs.dropdown', me._anyDropdownShown);
        },

        onDestroy: function () {
            const me = this;

            $(document).off('hide.bs.dropdown', me._hideHandler);
            $(document).off('show.bs.dropdown', me._anyDropdownShown);

            if (me._onCloseHandler) {
                $(document).off('click', me._onCloseHandler);
            }
        },

        _isCheckboxStateChanged: function () {
            const me = this;

            const currentlySelectedPostTagIds = _.keyBy(me.getCheckboxesState());
            return _.some(me.selectableItems, function (item) {
                const currentlyChecked = Boolean(currentlySelectedPostTagIds[item.id]);
                const previouslySelected = Boolean(item.selected);
                return currentlyChecked !== previouslySelected;
            });
        },

        onCheckboxChange: function () {
            const me = this;
            me.ui.controlButtons.toggleClass('hidden', !me._isCheckboxStateChanged());
        },

        shouldCloseDropdown: function (e) {
            const me = this;

            if (e.relatedTarget === me.ui.dropdownToggle[0]) {
                if (!me._manuallyClosing) {
                    return e.preventDefault();
                }
            }
        },

        onDropdownToggleClicked: function (e) {
            const me = this;

            if (me.ui.dropdown.hasClass('open')) {
                me.closeDropdown(true);
                e.stopPropagation();
                return false;
            }
        },

        onDropdownShown: function () {
            const me = this;

            me._onCloseHandler = function (e) {
                if (!_.isFunction(me.ui.dropdownMenu.has) || me.ui.dropdownMenu.has(e.target).length) {
                    return;
                }

                $(document).off('click', me._onCloseHandler);
                me.onCancelClicked();
            };
            $(document).on('click', me._onCloseHandler);
        },

        closeDropdown: function () {
            const me = this;

            if (!me.ui.dropdown.hasClass || !me.ui.dropdown.hasClass('open')) {
                return;
            }

            me._manuallyClosing = true;
            me.ui.dropdownToggle.attr('aria-expanded', 'false');
            me.ui.dropdown.removeClass('open').trigger('hidden.bs.dropdown');
            delete me._manuallyClosing;

            $(document).off('click', me._onCloseHandler);
        },

        onCancelClicked: function () {
            const me = this;

            me.resetState();
            me.closeDropdown();
        },

        resetState: function () {
            const me = this;

            me.updateDropdownCheckboxes(me.selectableItems);
            me.ui.controlButtons.toggleClass('hidden');
        },

        onApplyClicked: function () {
            const me = this;

            me.applyDropdownState();
            me.closeDropdown();

            return false;
        },

        updateDropdownCheckboxes: function (selectableItems) {
            const me = this;

            _.each(selectableItems, function (selectableItem) {
                const checkbox = me.$el.find(`#selectable-item-${selectableItem.id}`);
                checkbox.prop('checked', Boolean(selectableItem.selected));
            });
        },

        // returns an array of all the currently checked options.
        getCheckboxesState: function () {
            const me = this;

            return _.reduce(me.ui.labelCheckboxes, function (memo, checkbox) {
                checkbox = $(checkbox);
                if (checkbox.prop('checked')) {
                    memo.push(checkbox.data('post-tag-id'));
                }
                return memo;
            }, []);
        },

        onFilterKeyup: function () {
            const me = this;

            const filter = me.ui.filterInput.val();

            const visibleItemIds = _.keyBy(me.getVisibleItemIds(filter));

            _.each(me.selectableItems, function (selectableItem) {
                const $item = me.$el.find(`#select-container-${selectableItem.id}`);
                if (visibleItemIds[selectableItem.id]) {
                    $item.show();
                } else {
                    $item.hide();
                }
            });

            me.ui.searchClear.toggleClass('display-none', _.isEmpty(filter));
        },

        onClearSearch: function () {
            const me = this;

            me.ui.filterInput.val('');
            me.onFilterKeyup();
        },

        onBeforeRender: function () {
            const me = this;
            me.selectableItems = me.getSelectableItems();
        },

        serializeData: function () {
            const me = this;

            return {
                selectionSummary: me.getSelectionSummary(me.selectableItems),
                label: me.getLabelName(),
                selectableItems: me.selectableItems,
                showFilter: me.showFilter(),
                highlighted: me.isHighlighted()
            };
        },

        ///////////////////////////////////////
        // Methods subclasses can override.
        // called when the subclass should handle the dropdown being closed.
        applyDropdownState: _.noop,

        isHighlighted: function () {
            const me = this;
            return Boolean(_.find(me.selectableItems, {
                selected: true
            }));
        },

        showFilter: _.constant(false),

        getVisibleItemIds: function (filter) {
            const me = this;

            const lcFilter = filter.toLocaleLowerCase();
            return _(me.selectableItems)
                .filter(function (item) {
                    return !lcFilter || _.includes(item.labelName.toLocaleLowerCase(), lcFilter);
                })
                .map('id')
                .value();
        },

        getSelectableItems: function () {
            return [];
        },

        getSelectionSummary: function (selectableItems) {
            return '';
        },

        getLabelName: function () {
            return 'Selectable Items';
        }
    });
});
